var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 2,
    height: 40,
    fill: "#DA291C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 2,
    height: 40,
    transform: "rotate(-90 0 27)",
    fill: "#DA291C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0L26.0622 6.3H13.9378L20 0Z",
    fill: "#DA291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.92e7471a6023edb1b43aae0b5154d5f8.svg";
export { ForwardRef as ReactComponent };